module.exports = __webpack_public_path__ + "img/manage-access-icon-active.2705130f.svg";